import React from 'react';
import styled from "styled-components";
import bannerBottom from "../images/bannerBottom.svg";
import banner5 from "../images/banner5.png";
import {Button} from "antd";
import {Link} from "react-router-dom";
import {mobileSizeRaw} from "../config";

const StyledMainBanner = styled.div`
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    justify-content: center;
    min-width: 1200px;
    background: #F2F2F4;
    position: relative;
    height: 400px;
    overflow: hidden;

    .ant-btn {
        font-weight: 500;
        font-size: 18px;
        line-height: 130%;
        border: 1px solid #5B77CB;
        padding: 17px 28px;
        height: auto;
        background: transparent;
        border-radius: 4px;
        margin-top: 32px;
        margin-bottom: 24px;
        min-width: 163px;

        &:hover {
            background: #5B77CB;
            border: 1px solid #5B77CB;

            span {
                color: #ffffff;
            }
        }

        span {
            color: #5B77CB;
        }
    }

    .left {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 110px;
    }

    img {
        width: 954px;
        object-fit: contain;
        position: absolute;
        right: -206px;
        bottom: -146px;
    }

    h2 {
        font-weight: 500;
        font-size: 17.852px;
        line-height: 22px;

        color: #5B77CB;
    }

    h1 {
        width: 448px;
        text-align: start;
        font-weight: 600;
        font-size: 32px;
        line-height: 98.8%;

        color: #000000;

        span {
            color: #5b77cb;
        }
    }

    h3 {
        font-weight: 400;
        font-size: 18px;
        line-height: 140%;

        color: #000000;
    }

    @media screen and (max-width: 999px) {
        justify-content: flex-start;
        padding-top: 70px;
        height: 620px;
        min-width: 480px;

        .left {
            margin-left: 20px;
        }

        img {
            width: 700px;
            object-fit: contain;
            position: absolute;
            right: -180px;
            bottom: -110px;
        }
    }
    @media screen and (${mobileSizeRaw}) {
        min-width: 360px;
        .left {
        }

        h1 {
            width: 248px;
        }

        img {
            width: 620px;
            object-fit: contain;
            position: absolute;
            right: -200px;
            bottom: -100px;
        }
    }
`;


function Banner4() {
    return (
        <StyledMainBanner>
            <span className="left">
                <h1>Изготовление инструмента по <span>чертежам заказчика</span></h1>
                <Link to={"/catalog"}>
                    <Button>
                        В каталог
                    </Button>
                </Link>
            </span>
            <img src={banner5} alt=""/>
        </StyledMainBanner>
    );
}

export default Banner4;